module.exports = __webpack_public_path__ + "static/media/slider-open-icon.193d1f0e.svg";